<template>
  <div class="wrapper py-4 px-3 pt-lg-5">
    <img
      class="bg d-none d-lg-block"
      src="@/assets/image/bg.png"
    >

    <div class="card mx-auto ml-lg-5 shadow-lg">
      <div class="card-body">
        <div class="px-3 px-lg-5 mt-4">
          <img src="@/assets/logo/logo.png">

          <div class="mt-3">
            <small class="text-muted font-weight-bold">
              Login Verification
            </small>
          </div>

          <div class="mt-3">
            <h4 class="font-weight-bold">
              Insert OTP code below
            </h4>
          </div>

          <form
            class="mt-4"
            @submit.prevent="verifyOtp"
          >
            <label class="mb-2 font-weight-bold">
              OTP code sent to email: {{ userEmail }}
            </label>

            <div class="d-flex justify-content-between otp-wrapper">
              <input
                v-for="(digit, index) in otp"
                :key="index"
                ref="otpInput"
                v-model="otp[index]"
                type="text"
                maxlength="1"
                class="form-control text-center otp-input"
                :class="{ 'is-invalid': $v.otp.$error }"
                @input="onOtpInput(index)"
                @keydown.backspace="onOtpBackspace(index)"
              >
            </div>

            <div
              v-if="$v.otp.$error"
              class="text-danger mt-2"
            >
              <small>
                Kode OTP harus 5 digit
              </small>
            </div>

            <button
              type="submit"
              class="btn btn-info btn-block mt-4 py-2"
            >
              <small
                v-if="!loading"
                class="font-weight-bold"
              >
                Verify
              </small>
              <div
                v-else
                class="text-center"
              >
                <div class="spinner-border spinner-border-sm">
                  <span class="sr-only">
                    Loading...
                  </span>
                </div>
              </div>
            </button>
          </form>

          <div class="text-center mt-3">
            <small class="text-muted">
              Have not received code?
              <a
                href="#"
                class="text-info font-weight-bold"
                @click.prevent="resendOtp"
              >
                Resend a new code
              </a>
            </small>
          </div>
        </div>
      </div>
    </div>

    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import Api from '@/utils/Api'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import { isToday } from 'date-fns'

export default {
  components: {
    ModalUnsuccessful
  },

  data () {
    return {
      otp: ['', '', '', '', ''],
      loading: false,
      userEmail: '',
      modal: {
        unsuccessful: false,
        textModal: ''
      }
    }
  },

  mounted () {
    this.userEmail = localStorage.getItem('mfaUserEmail')
  },

  methods: {
    onOtpInput (index) {
      if (this.otp[index] && index < 4) {
        this.$refs.otpInput[index + 1].focus()
      }
    },

    onOtpBackspace (index) {
      if (!this.otp[index] && index > 0) {
        this.$refs.otpInput[index - 1].focus()
      }
    },

    async verifyOtp () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.loading = true
      const otpCode = this.otp.join('')
      const userId = localStorage.getItem('mfaUserId')

      try {
        const res = await Api.auth.verifyOtpMfa({ userId, otpCode })
        if (res.data.status === 200 || res.data.status === 2001) {
          localStorage.removeItem('mfaUserId')
          localStorage.removeItem('mfaUserEmail')
          localStorage.res = JSON.stringify(res.data.data)
          localStorage.token = res.data.data.token
          localStorage.refreshToken = res.data.data.refreshToken
          localStorage.login = true
          try {
            const { data: profile } = await Api.users.me()
            localStorage.profile = JSON.stringify(profile)
            await this.setDefaultRoute()
            this.nextPage(profile)
            window.scrollTo(0, 0)
            this.loading = false
          } catch (error) {
            this.loading = false
            localStorage.clear()
            this.modal.textModal = this.$t('login.net-error')
            this.showModal('unsuccessful')
          }
        } else if (res.data.status === 40113) {
          if (this.$i18n.locale === 'en') {
            this.modal.textModal = 'Max Attempt Insert OTP MFA Reached'
          } else if (this.$i18n.locale === 'id') {
            this.modal.textModal = 'Percobaan untuk insert OTP MFA melebihi batas maksimal'
          }
          this.showModal()
        } else {
          if (this.$i18n.locale === 'en') {
            this.modal.textModal = 'OTP MFA not valid'
          } else if (this.$i18n.locale === 'id') {
            this.modal.textModal = 'OTP MFA tidak valid'
          }
          this.showModal()
        }
      } catch (e) {
        if (this.$i18n.locale === 'en') {
          this.modal.textModal = 'Failed verify OTP MFA'
        } else if (this.$i18n.locale === 'id') {
          this.modal.textModal = 'Gagal memverifikasi OTP MFA'
        }
        this.showModal()
      } finally {
        this.loading = false
      }
    },

    async resendOtp () {
      const userId = localStorage.getItem('mfaUserId')
      await Api.auth.resendOtpMfa({ userId })
    },

    showModal () {
      this.modal.unsuccessful = true
    },

    closeModal () {
      this.modal.unsuccessful = false
    },
    setDefaultRoute () {
      const profile = JSON.parse(localStorage.getItem('profile'))
      let routing = profile.role.permissions
      routing = routing.sort((a, b) => (a.level > b.level) ? 1 : ((b.level > a.level) ? -1 : 0))
      localStorage.setItem('defaultRoute', JSON.stringify(routing[0]))
    },
    nextPage ({ lastSubmissionDate }) {
      const defaultRouting = JSON.parse(localStorage.getItem('defaultRoute'))
      if ((defaultRouting.category === 'my_dhm' || defaultRouting.category === 'all_dhm') && defaultRouting.permissions.includes('add')) {
        if (lastSubmissionDate && isToday(new Date(lastSubmissionDate))) {
          this.$router.push({
            name: defaultRouting.category
          })
        } else {
          this.$router.push({
            name: 'success-login'
          })
        }
      } else {
        this.$router.replace({
          name: defaultRouting.category
        })
      }
    },
    revealPassword () {
      this.passwordType = this.passwordType === 'password'
        ? 'text'
        : 'password'
    }
  },

  validations: {
    otp: {
      required,
      minLength: minLength(5)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  align-items: center;
  background-color: #4c2e88;
  display: flex;
  min-height: 100vh;
}

.bg {
  bottom: 5vw;
  position: fixed;
  right: 5vw;
  width: 50.8vw;
}

.card {
  border-radius: 12px;
  margin: 0 auto;
  width: 455px;
}

.otp-wrapper {
  gap: 10px;
}

.otp-input {
  width: 52px;
  height: 56px;
  font-size: 22px;
  font-weight: bold;
  border-radius: 8px;
}
</style>
